export default __webpack_public_path__ + "static/media/woodcut-knight.c1bc6436.png";